import { render, staticRenderFns } from "./ProductAbstract.vue?vue&type=template&id=3a1b6f90"
import script from "./ProductAbstract.vue?vue&type=script&lang=js"
export * from "./ProductAbstract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports